/**
 * WidgetSkeleton — grijze placeholder-weergave van een widget, gebruikt in
 * edit-modus. Toont een voorbeeld-layout zonder echte inhoud: rustiger om te
 * verslepen/schalen en voorkomt geneste drag-and-drop (zoals shortcuts-tegels).
 * De vorm (`kind`) komt uit de registry per widget-type.
 */
import React from 'react';
import { Box } from '@mui/material';

const G1 = '#dfe4e6'; // donkerder grijs (blokken)
const G2 = '#eef1f2'; // lichter grijs (vlakken)

const Bar = ({ w = '100%', h = 8, mt = 0 }) => (
  <Box sx={{ width: w, height: h, mt, bgcolor: G1, borderRadius: '4px' }} />
);

function Tiles() {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
      {[0, 1, 2, 3].map((i) => (
        <Box key={i} sx={{
          display: 'flex', alignItems: 'center', gap: 1.25,
          bgcolor: G2, borderRadius: '0.75rem', p: 1.5, width: 172,
        }}>
          <Box sx={{ width: 34, height: 34, borderRadius: '0.55rem', bgcolor: G1, flexShrink: 0 }} />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Bar w="70%" />
            <Bar w="45%" mt={0.75} h={6} />
          </Box>
        </Box>
      ))}
    </Box>
  );
}

function List() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {[0, 1, 2].map((i) => (
        <Box key={i} sx={{
          display: 'flex', alignItems: 'center', gap: 1.5,
          bgcolor: G2, borderRadius: '0.5rem', p: 1.5, borderLeft: `3px solid ${G1}`,
        }}>
          <Box sx={{ width: 50, flexShrink: 0 }}><Bar w="80%" /></Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Bar w="75%" />
            <Bar w="50%" mt={0.75} h={6} />
          </Box>
        </Box>
      ))}
    </Box>
  );
}

function Generic() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
      <Bar w="90%" /><Bar w="100%" /><Bar w="65%" />
    </Box>
  );
}

function Blank() {
  // Lege widget: enkel een minimale hoogte zodat de kaart in edit-modus aanwezig is.
  return <Box sx={{ minHeight: 56 }} />;
}

export default function WidgetSkeleton({ meta }) {
  const kind = meta?.skeleton || 'generic';
  if (kind === 'tiles') return <Tiles />;
  if (kind === 'list') return <List />;
  if (kind === 'blank') return <Blank />;
  return <Generic />;
}
